import { render, staticRenderFns } from "./CaseNew.vue?vue&type=template&id=65c131b8&"
import script from "./CaseNew.jsx?vue&type=script&lang=js&"
export * from "./CaseNew.jsx?vue&type=script&lang=js&"
import style0 from "./CaseNew.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports